<template>
  <div class="banner">
      <div class="banner-c wrap-c">
          <h1 class="limited large-title">nonda Ambassador Program</h1>
          <h1 class="referral-title large-title">Refer a friend, <span class="first-price">Get $10 Cash</span></h1>
          <p class="get-title">Receive $10 cash for your first referral & $3 cash for each after.</p>
          <p class="get-title">The more you refer, the more you earn!</p>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  
})
</script>
<style lang="scss" scoped>
  .wrap-c {
      max-width: 1024px;
      margin: 0 auto;
      overflow: hidden;
  }
  .banner{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 186px;
      color: #fff;
      background-image: url("../../assets/imgs/information/banner.png");
      background-position: center;
      background-repeat: no-repeat;
      .banner-c{
        text-align: left;
        padding-right: 60px;
        .limited{
          height: 36px;
          line-height: 37px;
          font-size: 48px;
        }
        .referral-title{
          margin: 12px 0 0px;
          .first-price{
              color: #8EC870;
          }
        }
        .get-title{
          font-size: 18px;
          font-weight: bold;
        }
      }
  }
  @media screen and (max-width: 768px){
    .wrap-c{
      padding: 0 10px;
    }
    .banner{
        .referral-title{
          font-size: 26px;
        }
        .banner-c{
          padding: 0 10px;
          .limited{
            font-size: 26px;
          }
        }
    }
  }
</style>

